import { gb } from 'src/common/growthbook';

const SUPPORTED_ROOM_CODES = new Set([
  'offensivesecurityintro',
  'offensivesecurityintrokK',
  'defensivesecurityintro',
  'careersincyber',
  'searchskills',
]);

export const isTaskBreakdownSupported = (roomCode: string) =>
  SUPPORTED_ROOM_CODES.has(roomCode) && gb.isOn('break-down-second-third-rooms');
